import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { useCity } from "@/context/LocationContext";

const Footer = () => {
    const { city, postal } = useCity();
    const zoneLabel = city ? `${city}${postal ? " " + postal : ""} · Dépannage Express` : "Dépannage Express";
    return (
        <footer className="bg-[#0A0A0A] text-zinc-300 border-t border-black" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src="/logo-transparent.png"
                                alt="Artisan Serrurier Beauchamp"
                                className="h-12 w-auto object-contain"
                                data-testid="footer-brand-logo"
                            />
                            <div className="font-display font-bold text-lg uppercase tracking-tight text-white">
                                Atelier Beauchamp
                            </div>
                        </div>
                        <p className="mt-6 text-sm leading-relaxed text-zinc-400 max-w-md">
                            Artisan serrurier indépendant intervenant 24h/24 et 7j/7 dans la commune.
                            Ouverture de porte, dépannage, remplacement de serrure et pose de porte blindée.
                            Devis gratuit, intervention rapide, travail soigné.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-4">Services</div>
                        <ul className="space-y-2.5 text-sm">
                            <li><Link to="/ouverture-de-porte" className="hover:text-white transition-colors">Ouverture de porte</Link></li>
                            <li><Link to="/depannage-serrurier" className="hover:text-white transition-colors">Dépannage serrurier</Link></li>
                            <li><Link to="/remplacement-serrure" className="hover:text-white transition-colors">Remplacement de serrure</Link></li>
                            <li><Link to="/remplacement-serrure" className="hover:text-white transition-colors">Pose de porte blindée</Link></li>
                            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
                            <li><Link to="/contact" className="hover:text-white transition-colors">Devis gratuit</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-4">Contact</div>
                        <ul className="space-y-3.5 text-sm">
                            <li>
                                <a href="tel:+33649501843" className="flex items-start gap-3 hover:text-white transition-colors" data-testid="footer-phone-link">
                                    <Phone className="h-4 w-4 mt-0.5 text-[#E63946]" strokeWidth={2.4} />
                                    <span className="font-display font-bold text-white text-base">06 49 50 18 43</span>
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Clock className="h-4 w-4 mt-0.5 text-[#E63946]" strokeWidth={2.4} />
                                <span>24h/24 — 7j/7, jours fériés inclus</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="h-4 w-4 mt-0.5 text-[#E63946]" strokeWidth={2.4} />
                                <span><span className="block font-display font-bold text-white text-sm tracking-tight mb-1">{zoneLabel}</span>Intervention dans la commune — déplacement rapide jour et nuit.</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-zinc-500">
                    <div>© {new Date().getFullYear()} Atelier Beauchamp — Artisan serrurier. Tous droits réservés. · <span className="text-zinc-400">Assurance décennale April</span></div>
                    <div className="flex items-center gap-5">
                        <Link to="/mentions-legales" className="hover:text-white transition-colors uppercase tracking-[0.18em]" data-testid="footer-mentions-link">
                            Mentions légales & RGPD
                        </Link>
                        <span className="uppercase tracking-[0.18em]">Devis gratuit · Sans engagement</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
